import Vue from 'vue'
import App from './App.vue'
import 'vue2-animate/dist/vue2-animate.min.css';
new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js